import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const LOCALHOST = 'http://localhost:3800';
@Injectable({
  providedIn: 'root'
})
export class MovementsService {

  private api = environment.api+'/api/';

  constructor(
    private http: HttpClient
  ) { }

  getMovement(movemntId: number) {
    
  }


  getMovements(dateStart?, dateEnd?, cardNumber?, email?, name?, lastname?, companyId?,isMovementsVouchers?) {
    return this.http.post(this.api + 'movements', {
      dateStart: dateStart,
      dateEnd: dateEnd,
      cardNumber: cardNumber,
      email: email,
      name: name,
      lastname: lastname,
      companyId: companyId,
      isMovementsVouchers : isMovementsVouchers
    });
  }
}
